import { Model } from './Model';

export class EntityEvaluation extends Model {
  public className = 'entityEvaluation';
  public apiPath = undefined;
}
